import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import React  from 'react';

const styles = {
  card: {
    minWidth: 275,
    width: 'auto'
  },
  bullet: {
    display: 'inline-block',
    margin: '0 2px',
    transform: 'scale(0.8)',
  },
  title: {
    marginBottom: 16,
    fontSize: 18,
  },
  pos: {
    marginBottom: 12,
  },
};

function CardIdealConditions(props) {
  const { classes, spot } = props;

  return (
      <Card className={classes.card}>
        <CardContent>
          <Typography className={classes.title}>
          Ideal Conditions
          </Typography>
                <div >
                  <div style={{ color: "green" }}> Wave Heigh:  {spot.bestConditionsWaveHeightFrom} - {spot.bestConditionsWaveHeightTo} ft</div>
                  <div style={{ color: "grey" }}> Tide : {spot.bestConditionsTideFrom} - {spot.bestConditionsTideTo} ft</div>
                  <div style={{ color: "grey" }}> Wind : {spot.bestConditionsMaxWind} kts</div>
                  <div style={{ color: "grey" }}> Swell Direction : {spot.bestConditionsSwellDirection}</div>
                </div>
        </CardContent>
      </Card>
  );
}

CardIdealConditions.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(CardIdealConditions);
